import palette from "layouts/ThemeProvider/palette";

export default {
  MuiBackdrop: {
    root: {
      backgroundColor: palette.backdrop,
    },
  },
};
